import type { TradeSignal } from '@/models/marketData';
import { getSignalLabel } from '@/utils/marketCalculations';

export const SignalBadge = ({ signal }: { signal: TradeSignal }) => (
  <span className={`signal-badge signal-badge--${signal}`}>
    <span className="signal-badge__dot" />
    {getSignalLabel(signal)}
  </span>
);
